import React, { useMemo } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import type { Campaign } from 'c-sdk';
import type { User } from 'c-data';
import { useEntityData } from 'c-data';
import { NetworkRequestState } from 'c-data-layer';
import { UserProfilePopOver } from 'c-admin/Components';

const BookedBy: React.FC<{ campaign: Campaign }> = ({ campaign }) => {
    const userId = campaign?.user_id;
    const { getById, getLoadingById } = useEntityData<User>('User');
    const user = getById({ id: userId });

    const isLoading = useMemo(
        () => getLoadingById(userId).state === NetworkRequestState.InProgress,
        [userId, getLoadingById],
    );
    const username = useMemo(
        () =>
            user ? (
                <UserProfilePopOver userId={userId}>
                    <Box>
                        <Button variant="text">{user?.name}</Button>
                    </Box>
                </UserProfilePopOver>
            ) : null,
        [user, userId],
    );
    if (!user && isLoading)
        return (
            <>
                <CircularProgress size={15} />
            </>
        );

    if (!user) return <>-</>;

    return <>{username}</>;
};

export default BookedBy;
